<script setup lang="ts">
import type { MediaSection } from "~/layers/media/composables/useMediaPagination";
import { useMediaPagination, mediaCountLabel } from "~/layers/media/composables/useMediaPagination";

/**
 * Лента одной вкладки раздела медиа с нумерацией страниц: список, подпись
 * «Всего N …» и блок пагинации. Общий для первых страниц и страниц /pageN.
 */
const props = defineProps<{ section: MediaSection; page: number }>();

const { items, total, pageCount, pending, linkForPage } = useMediaPagination(props.section, () => props.page);
</script>

<template>
  <Container v-if="pending">
    <div class="grid md:grid-cols-3 gap-2">
      <MediaItemSkeleton v-for="i in 6" :key="i" />
    </div>
  </Container>
  <template v-else>
    <MediaList :data="items" />
    <NotResult v-if="total === 0" />
    <Container v-else>
      <div class="flex flex-col items-center gap-4 pt-10">
        <p class="text-14 text-primary/70">Всего {{ mediaCountLabel(section, total) }}</p>
        <AppPagination :page="page" :page-count="pageCount" :link-for="linkForPage" />
      </div>
    </Container>
  </template>
</template>
